export default "__VITE_ASSET__DdBzaAP8__"